import { Component, OnInit } from '@angular/core';
import { NavbarComponent } from '../../shared/components/navbar/navbar.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth-service/auth.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    NavbarComponent,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loginForm: FormGroup;
  loginType = 'annual-audit';

  private subheadMap: Record<string, string> = {
    'annual-audit': 'ตรวจนับครุภัณฑ์ประจำปี',
    'government-vehicle': 'การขออนุญาตใช้รถราชการ',
    'structure-audit': 'ตรวจนับสิ่งปลูกสร้างประจำปี',
  };

  private inferTypeFromReturnUrl(url: string | null): string | null {
    if (!url) return null;
    const map: [string, string][] = [
      ['/building-annual-audit', 'structure-audit'],
      ['/assets-annual-count', 'annual-audit'],
      ['/assets-annual', 'annual-audit'],
      ['/asset-government-vehicle', 'government-vehicle'],
    ];
    const found = map.find(([segment]) => url.includes(segment));
    return found ? found[1] : null;
  }

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authSrv: AuthService
  ) {
    this.loginForm = this.fb.group({
      idCard: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const t = this.inferTypeFromReturnUrl(params.get('returnUrl'));
      if (t) {
        this.loginType = t;
      }
    });
  }

  ngAfterViewInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const t = this.inferTypeFromReturnUrl(params.get('returnUrl'));
      if (t) {
        this.loginType = t;
        if (params.has('type')) {
          const returnUrl = params.get('returnUrl');
          const qp: Record<string, string> = {};
          if (returnUrl) qp['returnUrl'] = returnUrl;
          this.router.navigate([], { relativeTo: this.route, queryParams: qp, replaceUrl: true });
        }
      }
    });
  }

  get subheadText(): string {
    return this.subheadMap[this.loginType] || this.subheadMap['annual-audit'];
  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const idCard = this.loginForm.value.idCard;

    this.authSrv.userLogin(idCard, this.loginType).pipe(take(1)).subscribe((success) => {
        sessionStorage.setItem('sub_menu_code', this.loginType);
      if (success) {
        // this.router.navigateByUrl('/');
        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.router.navigateByUrl(returnUrl);
      }
    });
  }
}
